import React from "react";
import PropTypes from "prop-types";
import { Box, Tooltip } from "@mui/material";

const RedBubble = ({ count, tooltipText, size = "medium", sx = {}, pulse = true }) => {
  if (count === undefined || count === null || count <= 0) {
    return null;
  }

  const displayCount = count > 99 ? "99+" : count;
  const isSmall = size === "small";

  const bubble = (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: isSmall ? "18px" : "21px",
        height: isSmall ? "18px" : "21px",
        px: isSmall ? "5px" : "6px",
        borderRadius: "10px",
        background: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
        color: "#ffffff",
        fontSize: isSmall ? "0.68rem" : "0.72rem",
        fontWeight: 700,
        lineHeight: 1,
        letterSpacing: "0.02em",
        boxShadow: "0 2px 7px rgba(239, 68, 68, 0.45)",
        border: "1.5px solid rgba(255, 255, 255, 0.6)",
        userSelect: "none",
        transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
        animation: pulse ? "redBubblePulse 2.8s infinite ease-in-out" : "none",
        "&:hover": {
          transform: "scale(1.1)",
          boxShadow: "0 3px 10px rgba(239, 68, 68, 0.6)",
        },
        "@keyframes redBubblePulse": {
          "0%, 100%": {
            boxShadow: "0 2px 7px rgba(239, 68, 68, 0.45)",
            transform: "scale(1)",
          },
          "50%": {
            boxShadow: "0 0 12px rgba(239, 68, 68, 0.75)",
            transform: "scale(1.05)",
          },
        },
        ...sx,
      }}
    >
      {displayCount}
    </Box>
  );

  if (tooltipText) {
    return (
      <Tooltip title={tooltipText} arrow placement="top">
        {bubble}
      </Tooltip>
    );
  }

  return bubble;
};

RedBubble.propTypes = {
  count: PropTypes.number,
  tooltipText: PropTypes.string,
  size: PropTypes.oneOf(["small", "medium"]),
  sx: PropTypes.object,
  pulse: PropTypes.bool,
};

export default RedBubble;
